var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgStudent = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 56 56",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M27.794 9.476a2.333 2.333 0 0 1 1.645.014l22.735 8.785a2.334 2.334 0 0 1 .09 4.316l-7.93 3.447V38.83c0 1.303-.652 2.52-1.736 3.242l-.48.32a25.453 25.453 0 0 1-28.237 0l-.479-.32a3.897 3.897 0 0 1-1.735-3.242V25.866l-2.334-.963v5.43a2.333 2.333 0 1 1-4.666 0v-7.357l-.89-.368a2.333 2.333 0 0 1 .086-4.347l23.931-8.785Zm1.734 22.997 10.139-4.406v10.351l-.137.091a20.785 20.785 0 0 1-23.06 0l-.137-.09V27.792l11.375 4.697a2.333 2.333 0 0 0 1.82-.017ZM11.09 20.58l17.485 7.22 16.613-7.22-16.61-6.419-17.488 6.42Z",
  fill: "currentColor"
})));
export default SvgStudent;